import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Wallbox } from '../../../../core/src/shared/enums';
export const WallboxTypeSelect = ({
  value,
  onChange,
}: {
  value: Wallbox;
  onChange: (value: Wallbox) => void;
}) => {
  return (
    <FormControl>
      <InputLabel id="wallbox-type-label">
        <FormattedMessage
          id="settings.service.wallbox_type.label"
          defaultMessage="Wallbox"
        />
      </InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value as Wallbox)}
        labelId="wallbox-type-label"
        size="medium"
        label={
          <FormattedMessage
            id="settings.service.wallbox_type.label"
            defaultMessage="Wallbox"
          />
        }
      >
        <MenuItem value={Wallbox.Solax} key={Wallbox.Solax}>
          <FormattedMessage
            id="wallbox.solax"
            defaultMessage="Solax - komunikace přes střídač"
          />
        </MenuItem>
        <MenuItem value={Wallbox.SolaxEvCharger} key={Wallbox.SolaxEvCharger}>
          <FormattedMessage
            id="wallbox.solax-ev-charger"
            defaultMessage="Solax - komunikace přes Infigy"
          />
        </MenuItem>
        <MenuItem value={Wallbox.Olife} key={Wallbox.Olife}>
          <FormattedMessage id="wallbox.olife" defaultMessage="Olife" />
        </MenuItem>
        <MenuItem value={Wallbox.GoodweEvCharger} key={Wallbox.GoodweEvCharger}>
          <FormattedMessage
            id="wallbox.goodwe-ev-charger"
            defaultMessage="Goodwe"
          />
        </MenuItem>
        <MenuItem value={Wallbox.EvMate} key={Wallbox.EvMate}>
          <FormattedMessage id="wallbox.evmate" defaultMessage="EVmate" />
        </MenuItem>
        <MenuItem
          value={Wallbox.VictronEvCharger}
          key={Wallbox.VictronEvCharger}
        >
          <FormattedMessage
            id="wallbox.victron-ev-charger"
            defaultMessage="Victron EV Charger"
          />
        </MenuItem>
        <MenuItem value={Wallbox.Alfen} key={Wallbox.Alfen}>
          <FormattedMessage id="wallbox.alfen" defaultMessage="Alfen" />
        </MenuItem>
        <MenuItem value={Wallbox.Ecovolter} key={Wallbox.Ecovolter}>
          <FormattedMessage id="wallbox.ecovolter" defaultMessage="EcoVolter" />
        </MenuItem>
        <MenuItem value={Wallbox.None} key={Wallbox.None}>
          <FormattedMessage id="wallbox.none" defaultMessage="Žádný" />
        </MenuItem>
      </Select>
    </FormControl>
  );
};
